import { useQuery } from "react-query";
import { apiGet } from "@shared/queryHooks/api";
import queryString from "query-string";
import { JobFilters } from "@shared/types/jobFilters";

/* API requests
--===================================================-- */
const getJobFilters = async (jobId, hiringStageId): Promise<JobFilters> => {
  if (jobId != undefined) {
    const params = `?${queryString.stringify({ hiring_stage_id: hiringStageId })}`;
    return await apiGet({ path: `/jobs/${jobId}/filters${params}` });
  }
};

/* Hooks
--===================================================-- */
export function useJobFilters({ jobId, hiringStageId }: { jobId?: number; hiringStageId: number }) {
  return useQuery<JobFilters>(
    ["jobFilters", jobId, hiringStageId],
    () => getJobFilters(jobId, hiringStageId),
    {
      refetchOnWindowFocus: false,
    },
  );
}
